import { ViewItem } from './itemModel'
import { CSSProperties } from 'styled-components'
import { gold } from '@ant-design/colors'

export type Props = {
  item: Pick<ViewItem, 'isEntireRowDisabled' | 'isEmptyRow'>
  openOverrideDialog: () => void
  canCustomize: boolean
  isCustomized: boolean
}

export const customizedBorderBottom = `3px solid ${gold.primary}`

export const CustomizedValueDisplay = ({ isCustomized, children }: React.PropsWithChildren<{ isCustomized: boolean }>) => {
  return <span style={isCustomized ? { borderBottom: customizedBorderBottom } : undefined}>
    {children}
  </span>
}

const getCustomizationStyle = (isCustomized: boolean, isDisabled: boolean, canCustomize: boolean): CSSProperties => {
  if (!canCustomize) {
    return {}
  }

  return {
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    borderBottom: isCustomized ? customizedBorderBottom : undefined
  }
}

export const CustomizableValue = ({item, openOverrideDialog, children, canCustomize, isCustomized}: React.PropsWithChildren<Props>) => {
  if (item.isEmptyRow) {
    return <></>
  }

  return <span
    style={getCustomizationStyle(isCustomized, item.isEntireRowDisabled, canCustomize)}
    onClick={() => { canCustomize && openOverrideDialog() }}
  >
    {children}
  </span>
}

export default CustomizableValue